import { Feature } from '../enums/Feature';
export const isFeatureEnabled = (settings, feature) => {
    const params = new URLSearchParams(location.search);
    if (!settings) {
        return false;
    }
    switch (feature) {
        case Feature.saveToProfile:
            return (params.get('enableSaveToProfile') === 'true' ||
                (params.get('enableSaveToProfile') !== 'false' &&
                    settings.general.enableSaveToProfile === true));
        default:
            return false;
    }
};
//# sourceMappingURL=featureEnabled.js.map